import React from 'react'
import { useTranslation } from 'react-i18next'

import { Column } from 'primereact/column'

import {
  BooleanBodyTemplate,
  BooleanFilterTemplate,
  DecimalBodyTemplate,
  DecimalFilterTemplate,
  PackagingIdentifierBodyTemplate,
  PackagingIdentifierFilterTemplate,
  PackagingTypeBodyTemplate,
  PackagingTypeFilterTemplate,
  PropertyIdentifierBodyTemplate,
  PropertyIdentifierFilterTemplate,
  WeightUnitBodyTemplate,
} from '../../../../../../../../components/tableTemplates'
import { DeliveryForecastDespatchAdvicePackagingMaterial } from '../../../../../../../../data/models'
import { ConfigurableTable } from '../../../../../../../../utils/wrapper'
import { TableConfig } from '../../../../../../../ui-config/data'

type Props = {
  config: TableConfig
  packagingData?: DeliveryForecastDespatchAdvicePackagingMaterial
  isLoading: boolean
}

export const PackagingMaterialTable: React.FC<Props> = ({
  config,
  packagingData,
  isLoading,
}) => {
  const { t } = useTranslation()

  const headerTitle = t(
    'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.info.dialog.packagingMaterial.table.title',
  )

  return (
    <ConfigurableTable
      config={config}
      data={[packagingData]}
      headerTitle={headerTitle}
      isLoading={isLoading}
      stateKey="" //"table-delivery-forecast-despatch-advice-add-packaging"
    >
      <Column field="PackagingDataId" dataType="text" filter></Column>
      <Column field="Description"></Column>
      <Column
        field="PackagingMaterial"
        dataType="text"
        body={(data: DeliveryForecastDespatchAdvicePackagingMaterial) =>
          PackagingTypeBodyTemplate(data?.PackagingMaterial)
        }
        filterElement={PackagingTypeFilterTemplate}
        filter={true}
        showFilterMatchModes={false}
      ></Column>
      <Column
        field="TareWeight.Value"
        dataType="numeric"
        body={(data: DeliveryForecastDespatchAdvicePackagingMaterial) =>
          DecimalBodyTemplate(data?.TareWeight?.Value || 0)
        }
        filterElement={DecimalFilterTemplate}
      ></Column>
      <Column
        field="TareWeight.Unit"
        dataType="text"
        body={(data: DeliveryForecastDespatchAdvicePackagingMaterial) =>
          WeightUnitBodyTemplate(data?.TareWeight?.Unit)
        }
        showFilterMatchModes={false}
      ></Column>
      <Column
        field="PackagingIdentifier"
        dataType="text"
        body={(data: DeliveryForecastDespatchAdvicePackagingMaterial) =>
          PackagingIdentifierBodyTemplate(data?.PackagingIdentifier)
        }
        filterElement={PackagingIdentifierFilterTemplate}
        showFilterMatchModes={false}
      ></Column>
      <Column
        field="PropertyIdentifier"
        dataType="text"
        body={(data: DeliveryForecastDespatchAdvicePackagingMaterial) =>
          PropertyIdentifierBodyTemplate(data?.PropertyIdentifier)
        }
        filterElement={PropertyIdentifierFilterTemplate}
        showFilterMatchModes={false}
      ></Column>
      <Column
        field="IsStackable"
        dataType="text"
        body={(data: DeliveryForecastDespatchAdvicePackagingMaterial) =>
          BooleanBodyTemplate(data?.IsStackable)
        }
        filterElement={BooleanFilterTemplate}
        showFilterMatchModes={false}
      ></Column>
    </ConfigurableTable>
  )
}
